<template>
    <v-slider :class="{'mobile-view': $vuetify.breakpoint.sm || $vuetify.breakpoint.xs, 'desktop-view': !$vuetify.breakpoint.sm && !$vuetify.breakpoint.xs}"
              v-model="selectedPeriod" vertical
              track-color="white" track-fill-color="green"
              :thumb-color="thumbColor" thumb-label="always" thumb-size="50"
              ticks="always" tick-size="10" :max="periods.length-1"
              @input="onSliderChange">
        <template v-slot:thumb-label="{value}">
            {{ periods[value].text }}
        </template>
    </v-slider>
</template>

<script>
    import moment from 'moment'

    export default {
        name: 'MapTimeline',
        computed: {
            periods() {
                let periods = []

                // Add past years (manually)
                periods.push({
                    text: '2019',
                    toDate: moment().year(2019).endOf('year').format("YYYY-MM-DD")
                })

                periods.push({
                    text: '2020',
                    toDate: moment().year(2020).endOf('year').format("YYYY-MM-DD")
                })

                periods.push({
                    text: '2021',
                    toDate: moment().year(2021).endOf('year').format("YYYY-MM-DD")
                })

                // Create list of months until now
                for (let idx=0; idx<=this.now.month(); idx++) {
                    let month = moment().month(idx)

                    periods.push({
                        text: month.format('MMM'),
                        toDate: month.endOf('month').format("YYYY-MM-DD")
                    })
                }

                return periods
            }
        },
        data: () => ({
            now: moment(),
            selectedPeriod: 0,
            thumbColor: 'green'
        }),
        methods: {
            onSliderChange(idx) {
                // Set thumb-color based on selection
                // [0] = 2020
                // [1..11] = months
                this.thumbColor = (idx > 1) ? 'green' : 'grey';

                this.$emit('range-change', this.periods[idx].toDate)
            }
        },
        mounted() {
            // Init slider
            this.selectedPeriod = this.now.month() + 2 // add number of years
        }
    }
</script>

<style lang="scss">
    div > span.v-slider__tick {
        background-color:white;
    }
    div > span.v-slider__tick:last-child {
        background-color:grey;
    }
    div > span.v-slider__tick--filled {
        background-color:green;
    }

    // Conditional class switch
    div > .mobile-view {
        position:absolute;
        bottom:100px;
        left:45px;
    }
    div > .desktop-view {
        position:absolute;
        bottom: 40px;
        left: 40px;
    }
</style>
